import { MediaserverVideoSetting } from 'features/mediaserver-settings/domain/models/mediaserver-video-setting';
import {
  useReadMediaserverVideoSettingQuery,
  useUpdateMediaserverVideoSettingMutation,
} from 'features/mediaserver-settings/domain/queries/media-video-queries';

export interface IMediaserverVideoSettingHook {
  isLoadingMediaserverVideoSetting: boolean;

  mediaserverVideoSetting: MediaserverVideoSetting;
  setMediaserverVideoSetting: (value: MediaserverVideoSetting) => void;
}

const useMediaserverVideoSetting = (): IMediaserverVideoSettingHook => {
  const {
    isLoading: isLoadingMediaserverVideoSetting,
    data: mediaserverVideoSettingResponse,
    isFetching: isFetchingMediaserverVideoSetting,
  } = useReadMediaserverVideoSettingQuery();
  const { mutate: executeUpdateMediaserverVideoSetting, isPending: isLoadingUpdateMediaserverVideoSetting } =
    useUpdateMediaserverVideoSettingMutation();

  const setMediaserverVideoSetting = (value: MediaserverVideoSetting) => {
    executeUpdateMediaserverVideoSetting({
      mediaserverVideoSetting: value,
    });
  };

  const mediaServerVideoSetting = () =>
    mediaserverVideoSettingResponse?.mediaserverVideoSetting ?? MediaserverVideoSetting.MediaserverVideoDisabled;

  return {
    isLoadingMediaserverVideoSetting:
      isLoadingMediaserverVideoSetting || isFetchingMediaserverVideoSetting || isLoadingUpdateMediaserverVideoSetting,

    mediaserverVideoSetting: mediaServerVideoSetting(),
    setMediaserverVideoSetting,
  };
};

export default useMediaserverVideoSetting;
